import React, { useRef, useState, useEffect } from 'react'
import "./AdsUpload.css"
import AdminSaveHeader from '../../../components/CommonComponents/AdminSaveHeader'
import MessageLabel from '../../../components/CommonComponents/MessageLabel'
import FormContainer from '../../../components/CommonComponents/FormContainer'
import LeftWrapper from '../../../components/CommonComponents/LeftWrapper'
import Wrapper from '../../../components/CommonComponents/Wrapper'
import MessageBox from '../../../components/CommonComponents/MessageBox'
import RightWrapper from '../../../components/CommonComponents/RightWrapper'
import AdminCustomButton from '../../../components/CommonComponents/AdminCustomButton'
import MessageHeading from '../../../components/CommonComponents/MessageHeading'
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { useParams } from 'react-router-dom'
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminBackNavigation from '../../../components/CommonComponents/AdminBackNavigation'
import AdminCustomInput from '../../../components/CommonComponents/AdminCustomInput'
import AdminCustomSelect from '../../../components/CommonComponents/AdminCustomSelect'
import AdminSwitch from '../../../components/CommonComponents/AdminSwitch'
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from "../../../CustomFields/saveCustomFieldsStrict";

const AdsUpload = (props) => {

    const { id } = useParams();
    const access_token = localStorage.getItem("access_token");
    const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + access_token,
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
    };

    const [editUser, setEditUser] = useState({
        advertiser_id: "",
        status: "",
        ads_name: "",
        ads_slug: "",
        ads_position: '',
        ads_upload_type: "",
        ads_video: "",
        ads_path: "",
        ads_category: "",
        age: "",
        devices: "",
        gender: "",
        ads_redirection_url: "",
        schedule: "",
    })
    const [editname, setEditName] = useState({
        ads_name: "",
    })
    const [formData, setFormData] = useState({
    });


    const [advertisement_videos_upload, setAdvertisement_videos_upload] = useState("");

    const [validationMessagetitle, setValidationMessagetitle] = useState("");
    const [isValidationHiddentitle, setIsValidationHiddentitle] = useState(true);

    const [validationMessageuser_ads_upload_type, setValidationMessageads_upload_type] =
        useState("");
    const [isValidationHiddenads_upload_type, setIsValidationHiddenads_upload_type] =
        useState(true);

    const [processing, setProcessing] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false);
    const [customFieldValues, setCustomFieldValues] = useState({});

    const titleInputRef = useRef(null);
    const ads_upload_typeInputRef = useRef(null);



    const handleInput = (e) => {
        const { name, value } = e.target;
        setEditUser((prevEditUser) => ({
            ...prevEditUser,
            [name]: value,
        }));
    };

    const handleInputenable = (e) => {
        if (e.target.checked === true) {
            setEditUser({ ...editUser, [e.target.name]: 1 });
        } else {
            setEditUser({ ...editUser, [e.target.name]: 0 });
        }
    };

    const [apiResponseage, setApiResponseage] = useState([]);
    const [advertisementResponseage, setAdvertisementResponseage] = useState([]);
    const [ads_positionselect, setAds_positionselect] = useState([]);
    const [ads_categoryselect, setAds_categoryselect] = useState([]);
    const [user_ads_upload_type, setUser_ads_upload_type] = useState([]);
    const [selectedAges, setSelectedAges] = useState([]);


    const [optionsgender, setOptionsgender] = useState([]);
    const [selectedValuesgender, setSelectedValuesgender] = useState([]);

    const [optionsdevices, setOptionsdevices] = useState([]);
    const [selectedValuesdevices, setSelectedValuesdevices] = useState([]);


    const handleSelectChangegender = (selectedOptionsgender) => {

        setFormData({
        });
        setSelectedValuesgender(selectedOptionsgender);
    };

    const handleSelectChangedevices = (selectedOptionsdevices) => {

        setFormData({
        });
        setSelectedValuesdevices(selectedOptionsdevices);
    };


    useEffect(() => {
        // Set the initially selected ages based on advertisement response
        const selectedValues = advertisementResponseage?.map((item) => item.value);
        setSelectedAges(selectedValues);
    }, [advertisementResponseage]);

    const fetchDataDetails = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_Baseurl}/admin/advertisement-edit/${id}`,
                { headers: headers }
            );

            setEditUser(response?.data?.data?.Advertisements);
            setEditName(response?.data?.data?.Advertisements);
            setApiResponseage(response?.data?.data?.age);
            // setApiResponseage(response?.data?.data?.age);
            setAds_positionselect(response?.data?.data?.ads_position_play);
            setAds_categoryselect(response?.data?.data?.admin_ads_category);
            setUser_ads_upload_type(response?.data?.data?.ads_upload_type);
            setAdvertisementResponseage(response?.data?.data?.Advertisements?.age);

            // create datat 
            const datagender = response?.data?.data?.gender;
            const datadevices = response?.data?.data?.devices;

            const formattedOptionsgender = datagender?.map((item) => ({
                value: item?.value,
                label: item?.name,
            }));
            const formattedOptionsdevices = datadevices?.map((item) => ({
                value: item?.value,
                label: item?.name,
            }));

            setOptionsgender(formattedOptionsgender);
            setOptionsdevices(formattedOptionsdevices);

            // Edit data
            const datagenderedit = response?.data?.data?.Advertisements?.gender;
            const datadevicesedit = response?.data?.data?.Advertisements?.devices;

            const formattedOptionsgenderedit = datagenderedit?.map((item) => ({
                value: item?.value,
                label: item?.name,
            }));
            const formattedOptionsdevicesedit = datadevicesedit?.map((item) => ({
                value: item?.value,
                label: item?.name,
            }));

            setSelectedValuesgender(formattedOptionsgenderedit);
            setSelectedValuesdevices(formattedOptionsdevicesedit);
            // edit datat 


        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchDataDetails();
    }, []);


    const handleCheckboxChange = (value) => {
        // Toggle the selection of an age
        if (selectedAges.includes(value)) {
            setSelectedAges(selectedAges.filter((age) => age !== value));
        } else {
            setSelectedAges([...selectedAges, value]);
        }
    };


    const handleStore = async (e) => {
        e.preventDefault();

        let focusInputRef = null;

        if (!editUser?.ads_name) {
            setValidationMessagetitle("Name cannot be empty.");
            setIsValidationHiddentitle(false);
            focusInputRef = titleInputRef;
        }
        if (!editUser?.ads_upload_type) {
            setValidationMessageads_upload_type("Please select Upload Type.");
            setIsValidationHiddenads_upload_type(false);
            focusInputRef = ads_upload_typeInputRef;
        }

        if (focusInputRef) {
            focusInputRef?.current?.focus();
            return;
        }

        const selectedAgesForRequest = selectedAges?.filter(Boolean);
        const editInputValue = {
            ads_name: editUser?.ads_name,
            ads_position: editUser?.ads_position,
            ads_upload_type: editUser?.ads_upload_type,
            ads_category: editUser?.ads_category,
            ads_redirection_url: editUser?.ads_redirection_url,
            location: editUser?.location,
            ads_path: editUser?.ads_path,
            status: editUser?.status,
            age: selectedAgesForRequest,
            gender: selectedValuesgender?.map((option) => option?.value),
            devices: selectedValuesdevices?.map((option) => option?.value),
            schedule: editUser?.schedule,
        };

        setProcessing(true);
        setShowOverlay(true);

        let firstApiStatus = false;
        let secondApiStatus = false;
        let resultApi = null;
        let resultApiError = null;

        try {
            const response = await fetch(
                `${process.env.REACT_APP_Baseurl}/admin/advertisement-update/${id}`,
                {
                    method: "PATCH",
                    headers,
                    body: JSON.stringify(editInputValue),
                }
            );
            const responseData = await response.json();

            if (responseData?.status) {
                firstApiStatus = true;
                resultApi = responseData;

                if (advertisement_videos_upload) {
                    const formData = new FormData();
                    formData.append("advertisement_videos_upload", advertisement_videos_upload);

                    const imageResponse = await axios.patch(
                        `${process.env.REACT_APP_Baseurl}/admin/advertisement-upload/${id}`,
                        formData,
                        { headers }
                    );

                    if (imageResponse?.data?.status) {
                        secondApiStatus = true;
                    }
                } else {
                    secondApiStatus = true;
                }
            } else {
                resultApiError = responseData;
            }
        } catch (error) {
            console.error("Error during API calls:", error);
        }

        if (firstApiStatus && secondApiStatus) {
            // save custom field values (strict)
            try {
                await saveCustomFieldsStrict({ baseURL: process.env.REACT_APP_Baseurl, headers, entityType: 'advertisement', entityId: id, values: customFieldValues });
            } catch (e) {
                toast.error(e.message);
                setProcessing(false);
                setShowOverlay(false);
                return;
            }
            toast.success(resultApi?.message);
            setTimeout(() => {
                window.location.reload();
            }, 3000);
        } else if (resultApiError) {
            toast.error(resultApiError?.message);
            setProcessing(false);
            setShowOverlay(false);
        } else {
            setProcessing(false);
            setShowOverlay(false);
        }
    };

    const [alluserads_upload_type, setAllUserads_upload_type] = useState("");
    function allads_upload_type() {
        console.log("alluserads_upload_type", alluserads_upload_type);
        switch (alluserads_upload_type) {
            case "tag_url":
                return (
                    <>
                        <MessageLabel text={"Advertisement Tag Url"} className="mandatorySimple" />
                        <AdminCustomInput id="ads_path" name="ads_path" value={editUser?.ads_path} onChange={handleInput} placeHolder={"Enter Advertisement Url"} />
                    </>);
            case "ads_video_upload":
                return (<>
                    <MessageLabel text={"Advertisement Video Upload"} />
                    <input type="file" id="video" className="form-control mb-2" name="video" accept="video/mp4, video/x-matroska, video/x-m4v, video/webm, video/quicktime, video/x-msvideo" onChange={(e) => setAdvertisement_videos_upload(e.target.files[0])} />

                    <MessageLabel text={"Advertisement Redirection URL"} className="mandatorySimple" />
                    <AdminCustomInput id="ads_redirection_url" name="ads_redirection_url" value={editUser?.ads_redirection_url} onChange={handleInput} placeHolder={"Enter Advertisement Redirection URL"} />

                </>);
            default:
                return null;
        }
    }
    function reloadResources() {
        setWithOutRefresh(prev => !prev)
    }
    return (
        <>
            <AdminBackNavigation path="/ads-list" text="Back" />
            {showOverlay && <Response_Processing></Response_Processing>}
            <AdminSaveHeader heading={"Edit Advertisement"} saveText={"Update"} saveMethod={handleStore} type="submit" />
            <FormContainer className="pb-5">
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={editname?.ads_name} />

                        <MessageLabel text={"Advertisement Name"} className="mandatorySimple" />
                        <AdminCustomInput
                            id="ads_name" name="ads_name" value={editUser?.ads_name} ref={titleInputRef}
                            onChange={handleInput} placeHolder={"Enter Advertisement Name"} error={validationMessagetitle}
                        />

                        <MessageLabel text={"Advertisement Upload Type"} className="mandatorySimple" />
                        <AdminCustomSelect
                            id="ads_upload_type" name="ads_upload_type" value={editUser?.ads_upload_type}
                            onChange={(e) => { handleInput(e); setAllUserads_upload_type(e.target.value); }}
                            ref={ads_upload_typeInputRef}
                            options={user_ads_upload_type?.map((item) => ({ name: item?.name, value: item?.value }))}
                            error={validationMessageuser_ads_upload_type}
                        />
                        <div className='mt-2'>{allads_upload_type()}</div>
                    </Wrapper>

                    <Wrapper>
                        <div className="card p-3 mt-3">
                            {/* <MessageHeading text="Additional Fields" /> */}
                            {/* Custom fields */}
                            <FieldRenderer2
                                pageIdentifier={"advertisement.edit"}
                                entityType={"advertisement"}
                                entityId={id}
                                text="Additional Fields"
                            />
                            <FieldRenderer
                                pageIdentifier={"advertisement.edit"}
                                entityType={"advertisement"}
                                entityId={id}
                                onChange={setCustomFieldValues}
                            />
                        </div>

                    </Wrapper>

                    <Wrapper>
                        <MessageHeading text={"Status Settings"} />

                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Ads Publish"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch id="status" name={'status'} checked={editUser?.status == 1 ? true : false} onChange={handleInputenable} defaultChecked={editUser?.status == 1 ? true : false} />
                            </div>
                        </div>
                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text={"Category"} />

                        <MessageLabel text={"Advertisement Position"} className="mandatorySimple" />
                        <AdminCustomSelect
                            id="ads_position"
                            name="ads_position"
                            value={editUser?.ads_position}
                            onChange={handleInput}
                            options={ads_positionselect?.filter(item => item?.value !== 'all')
                                ?.map((item) => ({
                                    name: item?.name,
                                    value: item?.value
                                }))}
                        />

                        <MessageLabel text={"Advertisement Category"} className="mandatorySimple" />
                        <AdminCustomSelect
                            id="ads_category"
                            name="ads_category"
                            value={editUser?.ads_category}
                            onChange={handleInput}
                            options={ads_categoryselect?.map((item) => ({
                                name: item?.name,
                                value: item?.value
                            }))}
                        />
                    </Wrapper>
                </RightWrapper>
                <AdminCustomButton id={"edit-ads-submit"} className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={"Update"} type={"submit"} />
            </FormContainer>

        </>
    )
}

export default AdsUpload;